import { ArrowRight } from "lucide-react";

const BOOK_URL = "/resource-optimizer/book";

const VARIANT_STYLES = {
  primary: {
    padding: "16px 36px",
    fontSize: "16px",
    borderRadius: "12px",
    iconSize: 18,
  },
  compact: {
    padding: "12px 26px",
    fontSize: "14px",
    borderRadius: "10px",
    iconSize: 14,
  },
  mini: {
    padding: "10px 20px",
    fontSize: "13px",
    borderRadius: "999px",
    iconSize: 13,
  },
};

export default function BookAuditButton({
  variant = "primary",
  label = "Book your free audit",
  showArrow = true,
  className = "",
  style = {},
  iconSize,
  href = BOOK_URL,
  ...rest
}) {
  const v = VARIANT_STYLES[variant] || VARIANT_STYLES.primary;

  return (
    <a
      href={href}
      className={`btn-primary book-audit-btn book-audit-btn--${variant} ${className}`.trim()}
      style={{
        padding: v.padding,
        fontSize: v.fontSize,
        borderRadius: v.borderRadius,
        ...style,
      }}
      {...rest}
    >
      {label}
      {showArrow && <ArrowRight size={iconSize ?? v.iconSize} strokeWidth={2.2} />}
    </a>
  );
}

export function BookAuditCTABar({
  title = "Ready to see what's automatable in your business?",
  subtitle = "30-minute audit. No cost. No commitment. Just numbers.",
  buttonLabel,
  variant = "compact",
}) {
  return (
    <div className="book-cta-bar">
      <div className="book-cta-bar-text">
        <p className="book-cta-bar-title">{title}</p>
        <p className="book-cta-bar-sub">{subtitle}</p>
      </div>
      <BookAuditButton variant={variant} label={buttonLabel} />

      <style>{`
        .book-cta-bar {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 32px;
          padding: 28px 32px;
          margin-top: 56px;
          border-radius: 18px;
          background: linear-gradient(135deg, rgba(40,180,174,0.08) 0%, rgba(40,180,174,0.02) 100%);
          border: 1px solid rgba(40,180,174,0.18);
          flex-wrap: wrap;
        }

        .book-cta-bar-text {
          flex: 1;
          min-width: 240px;
        }

        .book-cta-bar-title {
          font-family: 'Inter', sans-serif;
          font-size: 18px;
          font-weight: 700;
          color: var(--text-primary);
          margin: 0 0 6px;
          letter-spacing: -0.01em;
        }

        .book-cta-bar-sub {
          font-family: 'Inter', sans-serif;
          font-size: 14px;
          color: var(--text-secondary);
          margin: 0;
          font-weight: 400;
        }

        @media (max-width: 640px) {
          .book-cta-bar {
            padding: 22px 20px;
            gap: 18px;
          }
          .book-cta-bar-title {
            font-size: 16px;
          }
        }
      `}</style>
    </div>
  );
}
